module.exports = __webpack_public_path__ + "img/06.b3fe7f40.png";